import { render, staticRenderFns } from "./projectList.vue?vue&type=template&id=38252764&scoped=true&"
import script from "./projectList.vue?vue&type=script&lang=ts&"
export * from "./projectList.vue?vue&type=script&lang=ts&"
import style0 from "./projectList.vue?vue&type=style&index=0&id=38252764&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38252764",
  null
  
)

export default component.exports